import { httpClient } from "@/services";

export default {
	state: {
		settingsPositions: [],
		positionsPositions: [],
		filtersPositions: {},
		editPositions: {},
	},
	mutations: {
		updatePositions(state, { settings, items, filters }) {
			state.settingsPositions = settings;
			state.positionsPositions = items;
			state.filtersPositions = filters;
		},
		updateEditPositions(state, { department }) {
			state.editPositions = department;
		},
	},
	actions: {

		async deleteAccountPositions({ dispatch }, id) {
			try {
				const { data } = await httpClient.delete(`/info/positions/${ id }`);
				if (data && data.status) {
					dispatch('getAccountPositionsList', true);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async getAccountPositionsList({ commit, dispatch }) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get("/info/positions");
				if (data) {
					commit('updatePositions', data);
				}
				dispatch("actionPreloader", false);
			} catch (e) {
				console.error(e);
			}
		},
		async onAccountPositionsEdit({ commit, dispatch }, args ) {
			try {
				const { id, sendInfo } = args;
				const { data } = await httpClient.put(`/info/positions/${ id }`, sendInfo);
				if ( data ) {
					commit('updateAccountSettings', data);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });
			} catch (e) {
				console.error(e);
			}
		},
		async onAccountPositionsSave({ commit, dispatch }, args) {
			// dispatch("actionPreloader", true);
			try {
				const { sendInfo } = args;
				const { data } = await httpClient.post("/info/positions", sendInfo);

				if ( data ) {
					commit('updateAccountSettings', data);
					// dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},

		async getAccountPositionsEdit({ commit, dispatch }, id) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.get(`/info/positions/${ id }/edit`);

				if (data && data.status) {
					commit('updateEditPositions', data);
					dispatch("actionPreloader", false);
					return data;
				}
				dispatch('setAlert', { type: "error", message: "Save data error" });

			} catch (e) {
				console.error(e);
			}
		},
		// onDefaultList({ commit }) {
		// 	commit('updateDefaultList');
		// }
	},
	getters: {
		editPositions: s => s.editPositions,
		settingsPositions: s => s.settingsPositions,
		positionsPositions: s => s.positionsPositions,
		filtersPositions: s => s.filtersPositions,
	},
};
